import { render, staticRenderFns } from "./yjjc.vue?vue&type=template&id=3730abf7&scoped=true"
import script from "./yjjc.vue?vue&type=script&lang=js"
export * from "./yjjc.vue?vue&type=script&lang=js"
import style0 from "./yjjc.vue?vue&type=style&index=0&id=3730abf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3730abf7",
  null
  
)

export default component.exports